import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import StudentListItem from '../StudentListItem/StudentListItem';
import {
    InputGroup, Input, InputGroupText,
    Label, Row, Col, Button,
    Card, CardBody
} from 'reactstrap';
import Icon from '@mdi/react';
import { setTextSearch } from '../../redux';
import { mdiAccountArrowRightOutline, mdiAccountSearchOutline, mdiClose } from '@mdi/js';
import { Link } from 'react-router-dom';
import { matchSorter } from 'match-sorter';

import './StudentsSearch.css';

const StudentsSearch = ({ students, placeholder, onChange, fixedWidth, single }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const [foundStudents, setFoundStudents] = useState([]);

    const search = useSelector(state => state.search);

    useEffect(() => {
        const text = search?.text?.scopes?.students;
        if (!text || text?.length <=3)
            return setFoundStudents([]);
        setFoundStudents(matchSorter(students, text, {keys: ['firstname', 'lastname']}));
    }, [search?.text?.scopes?.students]);

    if (!students)
        return null;

    const doSearch = text => {
        dispatch(setTextSearch('students', text));
    };

    return (
        <Card color="light" className="text-dark">
            <CardBody>
                <Row className=" justify-content-md-center">
                    <Col md={12}>
                        <Label tag="h4">{ t('dashboard.search_student') }</Label>
                        <Label tag="em">{ t('dashboard.search_student_desc') }</Label>
                        <InputGroup className="mt-2">
                            <InputGroupText>
                                <Icon path={mdiAccountSearchOutline} size={1} />
                            </InputGroupText>
                            <Input
                                type="text"
                                className="form-control"
                                onChange={ e => doSearch(e.target.value) }
                                placeholder={ t('dashboard.search_student') }
                                value={search?.text?.scopes?.students}
                            />
                            {search?.text?.scopes?.students && (
                                <InputGroupText>
                                    <Icon onClick={() => doSearch('')} path={mdiClose} size={1} style={{cursor: 'pointer'}} />
                                </InputGroupText>
                            )}
                        </InputGroup>
                    </Col>
                </Row>
                {(search?.text?.scopes?.students?.length > 0) && (search?.text?.scopes?.students?.length < 3) && (
                    <Label tag="h5">
                        {t('dashboard.enter_at_least_3_characters')}
                    </Label>
                )}
                {(search?.text?.scopes?.students?.length >= 3) && (
                    <>
                        <Label tag="h5">
                            {t('dashboard.x_results', {x: foundStudents.length})}
                        </Label>
                        <Row className="row-cols-sm-1 row-cols-lg-1 mt-4">
                            { foundStudents?.map(student => (
                                <Col key={student.id} >
                                    <StudentListItem
                                        student={ student }
                                        className="mb-1"
                                        actions={(
                                            <Button tag={Link} to={ `/students/show/${ student.id }` } color="warning" size="sm">
                                                <Icon path={mdiAccountArrowRightOutline} size={1} />
                                            </Button>
                                        )}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </>
                )}
            </CardBody>
        </Card>
    );
}

export default StudentsSearch;
